import dayJs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import duration from "dayjs/plugin/duration";

export function initDayJs() {
    // @ts-ignore
    dayJs.extend(relativeTime);
    // @ts-ignore
    dayJs.extend(duration);
}